import { Component, OnInit, OnDestroy } from '@angular/core';
import { ManageSeguimentTecnicService } from './manage-seguiment-tecnic.service';
import { Router, ActivatedRoute } from '@angular/router';
import { MatDialog, MatDialogRef, MatDialogConfig } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../services/language.service';

import { ISeguimentTecnic, IProjectSeguimentTecnicResponse } from './manage-seguiment-tecnic.interfaces';
import { DialogSeguimentTecnic } from '../dialog/seguiment-tecnic/dialog.component.seguiment-tecnic';

import { DatePipe } from '@angular/common'

import { MatSidenav } from '@angular/material/sidenav';

import { fromEvent, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'mcrit-gestio-manage-seguiment-tecnic',
  templateUrl: './manage-seguiment-tecnic.component.html',
  styleUrls: ['./manage-seguiment-tecnic.component.scss'],
  providers: [ ManageSeguimentTecnicService, DatePipe ]
})
export class ManageSeguimentTecnicComponent implements OnInit, OnDestroy {
  public currentDate;
  private routeParamsSubs: any;
  private seguimentTecnicModel: ISeguimentTecnic = {
    'id': 'NEW',
    'projecte_codi': '',
    'titol': '',
    'ambit_proposta': '',
    'tipus': '',
    'sub_tipus': '',
    'participants': '',
    'assumpte': '',
    'data': '',
    'data_realitzacio': '',
    'hora': '',
    'acords': '',
    'lliuraments': '',
    'filename': '',
    'file': null,
    'data_avis': '',
    'avis_actiu': true,
    'lloc': ''
  };
  private projectCode: string;
  private unsubscriber : Subject<void> = new Subject<void>();

  public showDialog: boolean = false;
  public showAsyncProgress: boolean = false;
  public seguimentTecnicData: IProjectSeguimentTecnicResponse;
  public editSeguimentTecnicData: ISeguimentTecnic;
  public acumulat = {
    facturat: 0,
    cobrat: 0
  };

  public editSeguimentTecnic(seguiment: ISeguimentTecnic): void {
    this.editSeguimentTecnicData = Object.assign(
      {},
      this.seguimentTecnicModel,
      seguiment
    );

   let dialogSegTecRef=this.dialog.open(DialogSeguimentTecnic, {disableClose: true, width: '850px', height: '550px', data: this.editSeguimentTecnicData })
   
   dialogSegTecRef.afterClosed().subscribe(results => {
     if(!results)return;
     this.editSeguimentTecnicData = results;
     this.addOrUpdateUser();
   });
  }

  public addSeguimentTecnic(): void {
    this.editSeguimentTecnicData = Object.assign(
      {},
      this.seguimentTecnicModel,
      { projecte_codi : this.projectCode }
    );

    let dialogSegTecRef=this.dialog.open(DialogSeguimentTecnic, {disableClose: true, width: '850px', height: '550px', data: this.editSeguimentTecnicData })
   
    dialogSegTecRef.afterClosed().subscribe(results => {
      if(!results)return;
      this.editSeguimentTecnicData = results;
      this.addOrUpdateUser();
    });
  }

  public addOrUpdateUser(/*$event*/): void {
    this.showAsyncProgress = true;
    this.showDialog = false;
    if (this.editSeguimentTecnicData.id === 'NEW') {
      if (new Date(this.editSeguimentTecnicData.data_avis))this.editSeguimentTecnicData.data_avis = null;
      this.manageSeguimentTecnicService.create(this.editSeguimentTecnicData)
        .subscribe(newSeguiment => {
          this.seguimentTecnicData.seguiments = [newSeguiment, ...this.seguimentTecnicData.seguiments];
          this.showAsyncProgress = false;
        },
          err => console.log(err)
        );
    } else {
      this.manageSeguimentTecnicService.update(<number> this.editSeguimentTecnicData.id, this.editSeguimentTecnicData)
      .subscribe(updatedSeguiment => {
          this.seguimentTecnicData.seguiments = this.seguimentTecnicData.seguiments.map(seguiment =>
            seguiment.id === updatedSeguiment.id ? updatedSeguiment : seguiment
          );
          this.showAsyncProgress = false;
      },
        err => console.log(err)
      );
    }
  }

  public deleteSeguimentTecnic(seguimentTecnicToDelete: ISeguimentTecnic): void {
    if (confirm(this.translate.instant('seguimentTecnic.confirmarEsborrat'))) {
      this.showAsyncProgress = true;
      this.showDialog = false;
      this.manageSeguimentTecnicService.destroy(<number> seguimentTecnicToDelete.id)
        .subscribe(deletedSeguiment => {
          this.seguimentTecnicData.seguiments = this.seguimentTecnicData.seguiments
           .filter(seguiments => seguiments.id !== deletedSeguiment.id);
          this.showAsyncProgress = false;
        },
         err => console.log(err)
        );
    }
  }

  public goProject(){ this.router.navigate(['project',this.seguimentTecnicData.projectData.codi]);};
  
  public export(){
    var csvData = this.convertToCSV( this.seguimentTecnicData.seguiments);
    var a = document.createElement("a");
    a.setAttribute('style', 'display:none;');
    document.body.appendChild(a);
    var blob = new Blob([csvData.replace(/,/g,"").replace(/\./g,",")], { type: 'text/csv' });
    var url= window.URL.createObjectURL(blob);
    a.href = url;
    var x:Date = new Date();
    var link:string ="seguiment-tecnic_"+this.seguimentTecnicData.projectData.codi+"_"+ x.getMonth() +  "_" +  x.getDay() + '.csv';
    a.download = link.toLocaleLowerCase();
    a.click();
  }

  private convertToCSV(objArray) {
    var array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
    var str = '';
    var row = "";

    for (var index in objArray[0])row += index + ';';
    row = row.slice(0, -1);
    str += row + '\r\n';

    for (var i = 0; i < array.length; i++) {
        var line = '';
        for (var index in array[i]) {
            if (line != '') line += ';'
            line += array[i][index];
        }
        str += line + '\r\n';
    }
    return str;
  }

  constructor(public translate: TranslateService, public languageService: LanguageService, private manageSeguimentTecnicService: ManageSeguimentTecnicService, private route: ActivatedRoute, public dialog: MatDialog, private router: Router, private datePipe:DatePipe) { }

  ngOnInit() {
    this.currentDate = this.datePipe.transform(new Date(),"yyyy-MM-dd");
    this.routeParamsSubs = this.route.params.subscribe(params => {
      this.projectCode = params['id'];
      this.manageSeguimentTecnicService.getByProject(this.projectCode)
          .subscribe(
            data => { this.seguimentTecnicData = data;},
            error => console.log(error)
          );
    });
 
    history.pushState(null,  document.title, location.href);

    fromEvent(window, 'popstate').pipe(
      takeUntil(this.unsubscriber)
    ).subscribe((_) => {
      history.pushState(null, '');
    });

  }

  ngOnDestroy(): void {
    this.unsubscriber.next();
    this.unsubscriber.complete();
    this.routeParamsSubs.unsubscribe();
  }
  
}
